import graphql from './graphql';
import { UserListUsersByCourse, CourseEnrollUsers, UserCourseDeleteUser, CourseContentCount } from './Request';

const mapUsers = (users, totalEvaluations) =>
  users?.map(user => [
    user?.User?.fullName,
    user?.User?.Department?.name,
    user?.User?.JobTitle?.name,
    user?.User?.Terminal.name,
    {
      totalLessonsCompletedManual: user?.User?.UserEvaluations?.totalLessonsCompletedManual,
      totalLessonsCompletedAutomatic: user?.User?.UserEvaluations?.totalLessonsCompletedAutomatic,
      totalLessonsCount: totalEvaluations,
    },
    user?.User?.id,
    user?.wasUserEnrolled,
  ]);
const mapCourseTotals = courses => courses?.evaluationCount;
const mapGeneric = array => array?.map(item => item.name || '');

export const fetchCourseUsers = async ({
  courseId,
  fullName = '',
  department = null,
  jobTitle = null,
  terminal = null,
}) => {
  const promises = [];
  promises.push(
    UserListUsersByCourse({
      courseId,
      fullName,
      department,
      jobTitle,
      terminal,
    })
  );
  promises.push(
    graphql(
      'User_list',
      ['id', 'fullName', 'status', 'Department {name}', 'Terminal {name}', 'JobTitle {name}', 'payrollNum'],
      'query'
    )
  );

  const data = await Promise.all(promises);
  const courseTotalObject = await CourseContentCount({ courseId });
  const courseTotal = mapCourseTotals(courseTotalObject);
  const courseUsers = mapUsers(data[0], courseTotal);
  const courseUserIds = data[0].map(user => user.User.id);
  const activeUsers = data[1].User_list.filter(item => !courseUserIds.includes(item.id) && item.status === true);

  return { courseUsers, users: activeUsers };
};

export const fetchDropdownsInformation = async () => {
  const promises = [];
  promises.push(graphql('Department_list', 'name', 'query'));
  promises.push(graphql('JobTitle_list', 'name', 'query'));
  promises.push(graphql('Terminal_list', 'name', 'query'));

  const data = await Promise.all(promises);

  const departments = mapGeneric(data[0].Department_list);
  const jobTitles = mapGeneric(data[1].JobTitle_list);
  const terminals = mapGeneric(data[2].Terminal_list);

  return { departments, jobTitles, terminals };
};

export const enrollUsers = async (courseId, users) => CourseEnrollUsers(courseId, users);

export const userCourseDeleteUser = async (courseId, userId) => UserCourseDeleteUser(courseId, userId);

export default {
  fetchCourseUsers,
  fetchDropdownsInformation,
  enrollUsers,
  userCourseDeleteUser,
};
